import type { ArchivedInvoice, InvoiceKind, InvoiceMail, InvoiceMailResult, MailMessageView, UploadedInvoices } from '../../types/invoices'
import { request, requestBlob, requestUpload } from './http'

export const getInvoices = () => request<ArchivedInvoice[]>('/admin/invoices')

export const getInvoiceFile = (id: number) => requestBlob(`/admin/invoices/${id}/file`)

export const removeInvoice = (id: number) => request<{ ok: true }>(`/admin/invoices/${id}`, { method: 'DELETE' })

export const setInvoiceKind = (id: number, kind: InvoiceKind) =>
	request<{ ok: true }>(`/admin/invoices/${id}`, { method: 'PATCH', body: JSON.stringify({ kind }) })

export const dismissDuplicate = (id: number) => request<{ ok: true }>(`/admin/invoices/${id}/not-duplicate`, { method: 'POST' })

export const uploadInvoiceXml = (file: File, target: { mailId: number } | { kind: InvoiceKind }) =>
	requestUpload<UploadedInvoices>(
		'/admin/invoices/xml',
		file,
		'mailId' in target ? { mail_id: String(target.mailId) } : { kind: target.kind },
	)

export const getInvoiceMails = () => request<InvoiceMail[]>('/admin/invoice-mails')

export const retryInvoiceMail = (id: number) => request<InvoiceMailResult>(`/admin/invoice-mails/${id}/retry`, { method: 'POST' })

export const ignoreInvoiceMail = (id: number) => request<{ ok: true }>(`/admin/invoice-mails/${id}/ignore`, { method: 'POST' })

export const restoreInvoiceMail = (id: number) => request<{ ok: true }>(`/admin/invoice-mails/${id}/restore`, { method: 'POST' })

export const getInvoiceMailOriginal = (id: number) => requestBlob(`/admin/invoice-mails/${id}/original`)

export const getInvoiceMailMessage = (id: number) => request<{ messages: MailMessageView[] }>(`/admin/invoice-mails/${id}/message`)
